var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    style: {
      color: "grey"
    },
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-full w-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    rx: 30,
    fill: "transparent",
    stroke: "transparent",
    strokeWidth: 0,
    strokeOpacity: "100%",
    paintOrder: "stroke"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 24 24",
    fill: "#fff",
    x: 6,
    y: 6,
    role: "img",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3.25a4.25 4.25 0 1 0 0 8.5a4.25 4.25 0 0 0 0-8.5ZM7.25 7.5a2.75 2.75 0 1 1 5.5 0a2.75 2.75 0 0 1-5.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 17A2.25 2.25 0 0 1 6 14.75h.34c.027 0 .053.004.078.012l.866.283c.68.222 1.38.358 2.084.41a.302.302 0 0 0 .312-.239c.076-.327.174-.645.294-.952a.214.214 0 0 0-.192-.29a7.251 7.251 0 0 1-2.032-.355l-.866-.283a1.752 1.752 0 0 0-.543-.086H6A3.75 3.75 0 0 0 2.25 17v1.188c0 .754.546 1.396 1.29 1.517c2.157.353 4.337.527 6.517.524c.152 0 .247-.165.18-.3a6.958 6.958 0 0 1-.38-.914a.418.418 0 0 0-.388-.29a38.603 38.603 0 0 1-5.688-.5a.037.037 0 0 1-.031-.037V17Zm13.5-1.7a.75.75 0 1 0-1.5 0v1.773c0 .24.115.465.309.606l1 .728a.75.75 0 1 0 .882-1.214l-.691-.502V15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 22.3a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11Zm0-1.5a4 4 0 1 0 0-8a4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.7054e0e235ab314c5799c5a6ab891fe8.svg";
export { ForwardRef as ReactComponent };